import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import {
  dateTimeFieldToDate,
  getDateToday,
} from "../../../Utils/externalFunctions";
import {
  DaftarTransaksiColumns,
  DaftarUMKColumns,
} from "../contants/DaftarColumns";
import { useThemeContext } from "../../../Context/ThemeContext";
import useAxios from "../../../Utils/useAxios";
import getUMKList from "../services/getUMKList";
import getTransaksiList from "../services/getTransaksiList";

const ModalSimple = ({ selectedRencimp, modal, toggle }) => {
  const axiosInstance = useAxios();

  const [dataList, setDataList] = useState({ umk: [], transaksi: [] });
  const [pending, setPending] = useState({ umk: false, transaksi: false });

  useEffect(() => {
    updateFilter(selectedRencimp);
  }, [selectedRencimp]);

  const updateFilter = (selectedRencimp) => {
    const rencimp_id = selectedRencimp?.pk;

    if (rencimp_id !== undefined) {
      refreshUMKList(rencimp_id);
      refreshTransaksiList(rencimp_id);
    }

    // setFilteredUMKList(
    //   UMKList.filter((item) => item.anggaran_umk.includes(rencimp_id))
    // );
    // setFilteredTransaksiList(
    //   transaksiList.filter((item) =>
    //     item.anggaran_transaksi.includes(rencimp_id)
    //   )
    // );
  };

  const refreshUMKList = (id) => {
    setPending((prev) => ({ ...prev, umk: true }));
    getUMKList(axiosInstance, id).then((res) => {
      setDataList((prev) => ({ ...prev, umk: res.data }));
    }).finally(() => {
      setPending((prev) => ({ ...prev, umk: false }));
    });
  };
  const refreshTransaksiList = async (id) => {
    setPending((prev) => ({ ...prev, transaksi: true }));
    getTransaksiList(axiosInstance, id).then((res) => {
      setDataList((prev) => ({ ...prev, transaksi: res.data }));
    }).finally(() => {
      setPending((prev) => ({ ...prev, transaksi: false }));
    });
  };

  const GetDataTable = ({ title, daftarColumns, data, pending }) => {
    const { themeContext } = useThemeContext();

    const conditionalRowStyles = [
      {
        when: (row) =>
          dateTimeFieldToDate(row.date_created) === getDateToday("original"),
        style: (row) => ({
          backgroundColor: row.diajukan_oleh ? "pink" : "red",
        }),
      },
    ];

    return (
      <DataTable
        title={`Rincian ${title}`}
        columns={daftarColumns}
        data={data}
        pagination
        dense
        highlightOnHover
        persistTableHead
        conditionalRowStyles={conditionalRowStyles}
        progressPending={pending}
        theme={themeContext}
      />
    );
  };

  return (
    <Modal isOpen={modal} toggle={toggle} size="xl" scrollable={true}>
      <ModalHeader toggle={toggle}>Rincian UMK/Transaksi</ModalHeader>
      <ModalBody>
        <GetDataTable
          title={"UMK"}
          daftarColumns={DaftarUMKColumns}
          data={dataList.umk}
          pending={pending.umk}
        />
        <GetDataTable
          title={"Transaksi"}
          daftarColumns={DaftarTransaksiColumns}
          data={dataList.transaksi}
          pending={pending.transaksi}
        />
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalSimple;
